// Helpers for weight-based (per-kg) vs per-unit cart items.
// Weight items store `quantity` in KILOGRAMS (float) plus a `weight_grams` field for display.

export const WEIGHT_PRESETS = [250, 500, 1000];

export const isWeightItem = (item) => item?.unit === 'kg' || item?.weight_grams != null;

export const gramsOf = (item) => {
    if (item?.weight_grams != null) return item.weight_grams;
    return Math.round((item?.quantity || 0) * 1000);
};

// Minimum 100g, rounded to the nearest 50g.
export const normalizeGrams = (value) => {
    let n = Math.round((Number(value) || 0) / 50) * 50;
    if (n < 100) n = 100;
    return n;
};

export const formatGrams = (g) => {
    const n = Number(g) || 0;
    if (n >= 1000) return `${parseFloat((n / 1000).toFixed(2))}kg`;
    return `${n}g`;
};

// Short amount label used in order summaries / history.
export const qtyLabel = (item) => (isWeightItem(item) ? formatGrams(gramsOf(item)) : `${item.quantity}x`);

// Line total = price-per-kg * kg (or price-per-unit * qty), rounded to 2 dp.
export const lineTotal = (item) => Math.round((item?.price || 0) * (item?.quantity || 0) * 100) / 100;
